import apiClient from "../../axios/apiClient";

export const getRoomTypeList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_ROOMTYPELIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Room-Type`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_ROOMTYPELIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_ROOMTYPELIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveRoomTypeData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_ROOMTYPE_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Room-Type`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_ROOMTYPE_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_ROOMTYPE_REJECTED", payload: error.response });
    }
  };
  

  export const getRoomTypeListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_ROOMTYPELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Room-Type/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_ROOMTYPELISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_ROOMTYPELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateRoomTypeData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_ROOMTYPE_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Room-Type/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_ROOMTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_ROOMTYPE_REJECTED", payload: error.response });
  }
};


export const updateRoomTypeStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_ROOMTYPE_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Room-Type-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_ROOMTYPE_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_ROOMTYPE_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteRoomTypeData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_ROOMTYPE_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Room-Type/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_ROOMTYPE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_ROOMTYPE_REJECTED", payload: error.response });
  }
};